import jwtDecode from 'jwt-decode'
import localStorageHelper from '@/assets/modules/localStorageHelper'

export default {

  /**
   * Receives the user's JWT token and checks if it is valid.
   * If it can't be decoded or has expired, it is not valid.
   * @param {*} jwt The JWT token to be checked
   */
  checkJwt (jwt) {
    // Try catch loop, because jwt decoder throws an error if it is wrong.
    try {
      let token = jwtDecode(jwt)
      let exp = token.exp
      if (exp < new Date() / 1000) {
        // Token has expired.
        localStorageHelper.setData('user', 'token', null)
        return false
      }

      return true
    } catch (e) {
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/modules/signOn/jwtChecker.js